import { useState } from 'react';
import type { FunctionComponent } from 'react';

import Button from '../../../generic/Button/Button';
import { BUTTON_TYPE } from '../../../generic/Button/button-constants';
import Flex from '../../../generic/Flex';
import Section from '../../../shared/settings/SettingsPageSection';
import type { MfaMethodListItem } from '../../../../../shared/types/routes/auth/mfa';

import EmailSetupModal from './EmailSetupModal';
import { getTitleAndDescriptionByType } from './index';
import MethodHeader from './MethodHeader';

type Props = {
  method: MfaMethodListItem | undefined;
};

/**
 * Email MFA method section.
 * Displays setup button or method details.
 */
const EmailMethodSection: FunctionComponent<Props> = ({ method }) => {
  const [shouldShowSetupModal, setShouldShowSetupModal] = useState(false);

  const { title, description } = getTitleAndDescriptionByType('email');

  return (
    <>
      <EmailSetupModal show={shouldShowSetupModal} onHide={() => setShouldShowSetupModal(false)} />

      <Section>
        <Section.Right>
          {!method ? (
            <Flex direction="column" gap="4px" justify="flex-start" align="flex-start">
              <strong>{title}</strong>
              <div>{description}</div>
              <Button
                type={BUTTON_TYPE.PRIMARY}
                onClick={() => setShouldShowSetupModal(true)}
              >
                Enable
              </Button>
            </Flex>
          ) : (
            <MethodHeader method={method} />
          )}
        </Section.Right>
      </Section>
    </>
  );
};

export default EmailMethodSection;
